import { render, staticRenderFns } from "./HostingFeatures.vue?vue&type=template&id=7e561c87&"
import script from "./HostingFeatures.vue?vue&type=script&lang=js&"
export * from "./HostingFeatures.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports